import { StructuredObservationChoice } from './choice/StructuredObservationChoice'
import { StructuredObservationFreeInput } from './form/StructuredObservationFreeInput'
import { StructuredObservationItemFormLayout } from './form/StructuredObservationItemFormLayout'
import { StructuredObservationItemDialogue } from './list/dialogue/StructuredObservationItemDialogue'
import { StructuredObservationList } from './list/StructuredObservationList'

export const StructuredObservation = {
  Choice: StructuredObservationChoice,
  FreeInput: StructuredObservationFreeInput,
  ItemFormLayout: StructuredObservationItemFormLayout,
  List: StructuredObservationList,
  ItemDialogue: StructuredObservationItemDialogue,
}

export { useStructuredObservationDialog } from './list/StructuredObservationList.context'

export type { DetailInputMode } from './form/StructuredObservationItemFormLayout'
export type { DialogState } from './list/StructuredObservationList.context'
